import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Button from '../Button';
import Divider from '../Divider';
import Dropdown from '../Dropdown';
import Icon from '../Icon';
import StackView from '../StackView';
import Text from '../Text';

var _ref2 = /*#__PURE__*/React.createElement("strong", null, "This product is not published on Church Center.");

var _ref3 = /*#__PURE__*/React.createElement("strong", null, "Church Center is disabled.");

var _ref4 = /*#__PURE__*/React.createElement(Text, {
  size: "14px",
  weight: 700
}, "Web");

var _ref5 = /*#__PURE__*/React.createElement(Text, {
  size: "14px",
  weight: 700
}, "Mobile app");

var _ref6 = /*#__PURE__*/React.createElement(Divider, {
  margin: 0.5
});

export function ChurchCenterStatus(_ref) {
  var _ref$ccAppEnabled = _ref.ccAppEnabled,
      ccAppEnabled = _ref$ccAppEnabled === void 0 ? false : _ref$ccAppEnabled,
      _ref$ccPublishingEnab = _ref.ccPublishingEnabled,
      ccPublishingEnabled = _ref$ccPublishingEnab === void 0 ? false : _ref$ccPublishingEnab,
      _ref$ccWebEnabled = _ref.ccWebEnabled,
      ccWebEnabled = _ref$ccWebEnabled === void 0 ? false : _ref$ccWebEnabled,
      description = _ref.description,
      destinationLabel = _ref.destinationLabel,
      _ref$disabledDescript = _ref.disabledDescription,
      disabledDescription = _ref$disabledDescript === void 0 ? 'People cannot access this product on the web or mobile app.' : _ref$disabledDescript,
      _ref$dropdownProps = _ref.dropdownProps,
      dropdownProps = _ref$dropdownProps === void 0 ? {} : _ref$dropdownProps,
      icons = _ref.icons,
      productUrl = _ref.productUrl,
      settingsUrl = _ref.settingsUrl,
      props = _objectWithoutPropertiesLoose(_ref, ["ccAppEnabled", "ccPublishingEnabled", "ccWebEnabled", "description", "destinationLabel", "disabledDescription", "dropdownProps", "icons", "productUrl", "settingsUrl"]);

  var buttonProps = {
    distribution: 'start',
    fontWeight: 400,
    paddingHorizontal: 2,
    radius: 0,
    variant: 'naked'
  };
  var ccEnabled = ccAppEnabled || ccWebEnabled;

  var icon = _objectSpread({
    check: 'checkmark',
    exclamationTriangle: 'exclamation-triangle-filled',
    external: 'external',
    x: 'close'
  }, icons);

  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal",
    spacing: 1
  }, props), /*#__PURE__*/React.createElement(Dropdown, _extends({
    fontWeight: 400,
    placement: "bottom-end",
    popoverProps: _objectSpread({
      width: '280px'
    }, dropdownProps['popoverProps']),
    theme: "dark",
    title: "Church Center",
    variant: "outline"
  }, (!ccEnabled || !ccPublishingEnabled) && {
    iconLeft: {
      name: icon.exclamationTriangle,
      size: 'sm'
    }
  }, dropdownProps), /*#__PURE__*/React.createElement(StackView, {
    padding: 2,
    spacing: 2
  }, !ccPublishingEnabled ? /*#__PURE__*/React.createElement(Text, {
    size: "14px"
  }, _ref2, ' ', disabledDescription) : !ccEnabled ? /*#__PURE__*/React.createElement(Text, {
    size: "14px"
  }, _ref3, " ", disabledDescription) : /*#__PURE__*/React.createElement(Text, {
    size: "14px"
  }, description), ccEnabled && ccPublishingEnabled && /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    spacing: 3
  }, /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    alignment: "center",
    spacing: 0.5
  }, /*#__PURE__*/React.createElement(Icon, {
    color: ccWebEnabled ? 'success' : 'error',
    name: ccWebEnabled ? icon.check : icon.x,
    size: "sm"
  }), _ref4), /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    alignment: "center",
    spacing: 0.5
  }, /*#__PURE__*/React.createElement(Icon, {
    color: ccAppEnabled ? 'success' : 'error',
    name: ccAppEnabled ? icon.check : icon.x,
    size: "sm"
  }), _ref5))), _ref6, /*#__PURE__*/React.createElement(StackView, null, /*#__PURE__*/React.createElement(Button, _extends({
    external: true,
    title: "Update settings",
    to: settingsUrl
  }, buttonProps)), ccEnabled && ccPublishingEnabled && /*#__PURE__*/React.createElement(Button, _extends({
    external: true,
    to: productUrl
  }, buttonProps), "Visit ", destinationLabel, /*#__PURE__*/React.createElement(Icon, {
    color: "primary",
    name: icon.external,
    marginLeft: 1,
    size: "sm"
  })))));
}